export const setHeadlineTitle = (
  title: string,
  placeholderToReplace: string,
  titleReplacedValue: string,
  productsAmount: number
) =>
  title.replace(
    placeholderToReplace,
    `${titleReplacedValue} ${productsAmount}`
  );
